export default __webpack_public_path__ + "static/prometheuspipeline-d3bba04c513fbaf011a4534171a7c6f3.png";